var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "content" } }, [
    _c("div", { staticClass: "header col-md-12" }, [
      _c("div", { staticClass: "header-inner row align-items-center" }, [
        _c("div", { staticClass: "col left" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("sidebar.posbranchmanagement")) +
                " > " +
                _vm._s(_vm.$t("sidebar.all")) +
                "\n        "
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content col-md-12" },
      [
        !_vm.ready
          ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
          : _c("base-table", {
              attrs: { hidePagination: "" },
              scopedSlots: _vm._u([
                {
                  key: "thead",
                  fn: function() {
                    return [
                      _c("thead", [
                        _c("tr", [
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.posbranchname")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.posbranchnameshort")))
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(
                              _vm._s(_vm.$t("message.posbranchcountingstrock"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", [
                            _vm._v(_vm._s(_vm.$t("message.assignproducts")))
                          ])
                        ])
                      ])
                    ]
                  },
                  proxy: true
                },
                {
                  key: "tbody",
                  fn: function() {
                    return [
                      _c(
                        "tbody",
                        [
                          _c("tr", [
                            _vm.branches.length === 0
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "text-center",
                                    attrs: { colspan: "4" }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("message.notfounddata")) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.branches, function(branch, index) {
                            return _c("tr", { key: index }, [
                              _c(
                                "td",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "PosBranchEdit",
                                          query: {
                                            id: branch.branchId,
                                            name: branch.name
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(branch.name) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(branch.nameShort))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(branch.whName))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(branch.assignProducts.length))
                              ])
                            ])
                          })
                        ],
                        2
                      )
                    ]
                  },
                  proxy: true
                }
              ])
            })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d8998e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d8998e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/branch/All.vue
// module id = null
// module chunks = 